// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__MiS7L","options":"AnswerScale_options__1ayyX","selected":"AnswerScale_selected__1Pw5q"};